(function (scope) {
  'use strict';
  function selectPanels(panels, focus, budget) {
    var limit = Number(budget) || Infinity;
    return panels.filter(function (p) {
      return (focus === 'all' || p.goal === focus) && Number.isFinite(p.price) && p.price >= 0 && p.price <= limit;
    });
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { selectPanels: selectPanels };
  if (!scope || !scope.document) return;
  function init(root) {
    var form = root.querySelector('[data-hfc-finder]');
    if (!form || form.dataset.hfcReady === 'true') return;
    var cards = Array.from(root.querySelectorAll('.hfc-card[data-hfc-price]'));
    if (!cards.length) return;
    form.dataset.hfcReady = 'true';
    var panels = cards.map(function (card) {
      return { goal: card.dataset.hfcGoal, price: Number(card.dataset.hfcPrice) / 100,
        available: card.dataset.hfcAvailable === 'true',
        title: card.querySelector('h3').textContent.trim(),
        priceLabel: card.querySelector('.hfc-card-price').textContent.trim(),
        url: card.querySelector('.hfc-card-media').getAttribute('href') };
    });
    var error = form.querySelector('[data-hfc-finder-error]');
    var message = function (key) { return form.querySelector('[data-hfc-message="' + key + '"]').textContent.trim(); };
    var step = function (value) {
      form.querySelectorAll('[data-hfc-finder-step]').forEach(function (el) { el.hidden = el.dataset.hfcFinderStep !== String(value); });
      form.querySelectorAll('[data-hfc-progress]').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.hfcProgress === String(value));
      });
      error.textContent = '';
      var target = form.querySelector('[data-hfc-finder-step="' + value + '"] legend') || form.querySelector('[data-hfc-finder-result-title]');
      if (target) { target.tabIndex = -1; target.focus(); }
    };
    var selected = function (name) { var radio = form.querySelector('input[name="' + name + '"]:checked'); return radio ? radio.value : null; };
    var fail = function (text) { error.textContent = text; error.tabIndex = -1; error.focus(); };
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    form.querySelector('[data-hfc-finder-next]').addEventListener('click', function () {
      if (!selected('hfc_focus')) return fail(message('choose_focus'));
      step(2);
    });
    form.querySelector('[data-hfc-finder-back]').addEventListener('click', function () { step(1); });
    form.querySelector('[data-hfc-finder-reset]').addEventListener('click', function () { form.reset(); step(1); });
    form.querySelector('[data-hfc-finder-show]').addEventListener('click', function () {
      var focus = selected('hfc_focus'), budget = selected('hfc_budget');
      if (!focus) return fail(message('choose_focus'));
      if (budget === null) return fail(message('choose_budget'));
      var matches = selectPanels(panels, focus, budget);
      var results = form.querySelector('[data-hfc-finder-results]');
      results.replaceChildren();
      form.querySelector('[data-hfc-finder-summary]').textContent = matches.length ? message('found') : message('none');
      matches.forEach(function (panel) {
        var article = document.createElement('article'); article.className = 'hfc-finder-result-card';
        var title = document.createElement('h4'); title.textContent = panel.title;
        var price = document.createElement('p'); price.textContent = panel.priceLabel;
        var link = document.createElement('a'); link.className = 'hfc-btn'; link.href = panel.url;
        link.textContent = panel.available ? message('view_kit') : message('availability');
        article.append(title, price, link); results.append(article);
      });
      step(3);
    });
    root.querySelector('[data-hfc-finder-fallback]')?.setAttribute('hidden', '');
    form.hidden = false;
    if (scope.location && scope.location.hash === '#hfc-finder') {
      var initialShell = root.querySelector('[data-hfc-finder-shell]');
      if (initialShell) initialShell.open = true;
    }
    root.querySelectorAll('a[href="#hfc-finder"]').forEach(function (link) {
      link.addEventListener('click', function () {
        var shell = root.querySelector('[data-hfc-finder-shell]');
        if (shell) shell.open = true;
      });
    });
  }
  var start = function (parent) { parent.querySelectorAll('[data-hfc-siphox]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
})(typeof window === 'undefined' ? null : window);
